import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions as Extensions$1 } from 'vscode/vscode/vs/workbench/common/views';
import { VIEW_CONTAINER } from 'vscode/vscode/vs/workbench/contrib/files/browser/explorerViewlet';
import { TimelinePaneId } from 'vscode/vscode/vs/workbench/contrib/timeline/common/timeline';
import { ITimelineService } from 'vscode/vscode/vs/workbench/contrib/timeline/common/timeline.service';
import { TimelineHasProviderContext } from '../common/timelineService.js';
import { TimelinePane } from './timelinePane.js';
import { Extensions } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { MenuRegistry, MenuId } from 'vscode/vscode/vs/platform/actions/common/actions';
import { CommandsRegistry } from 'vscode/vscode/vs/platform/commands/common/commands';
import { ExplorerFolderContext } from 'vscode/vscode/vs/workbench/contrib/files/common/files';
import { ResourceContextKey } from 'vscode/vscode/vs/workbench/common/contextkeys';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { registerIcon } from 'vscode/vscode/vs/platform/theme/common/iconRegistry';

const _moduleId = "vs/workbench/contrib/timeline/browser/timeline.contribution";
const timelineViewIcon = registerIcon('timeline-view-icon', Codicon.history, ( localizeWithPath(_moduleId, 0, 'View icon of the timeline view.')));
const timelineOpenIcon = registerIcon('timeline-open', Codicon.history, ( localizeWithPath(_moduleId, 1, 'Icon for the open timeline action.')));
class TimelinePaneDescriptor {
    constructor() {
        this.id = TimelinePaneId;
        this.name = TimelinePane.TITLE;
        this.containerIcon = timelineViewIcon;
        this.ctorDescriptor = ( (new SyncDescriptor(TimelinePane)));
        this.order = 2;
        this.weight = 30;
        this.collapsed = true;
        this.canToggleVisibility = true;
        this.hideByDefault = false;
        this.canMoveView = true;
        this.when = TimelineHasProviderContext;
        this.focusCommand = { id: 'timeline.focus' };
    }
}
const configurationRegistry = ( (Registry.as(Extensions.Configuration)));
configurationRegistry.registerConfiguration({
    id: 'timeline',
    order: 1001,
    title: ( localizeWithPath(_moduleId, 2, "Timeline")),
    type: 'object',
    properties: {
        'timeline.pageSize': {
            type: ['number', 'null'],
            default: null,
            markdownDescription: ( localizeWithPath(
                _moduleId,
                3,
                "The number of items to show in the Timeline view by default and when loading more items. Setting to `null` (the default) will automatically choose a page size based on the visible area of the Timeline view."
            )),
        },
        'timeline.pageOnScroll': {
            type: 'boolean',
            default: false,
            description: ( localizeWithPath(
                _moduleId,
                4,
                "Experimental. Controls whether the Timeline view will load the next page of items when you scroll to the end of the list."
            )),
        },
    }
});
( (Registry.as(Extensions$1.ViewsRegistry))).registerViews([( (new TimelinePaneDescriptor()))], VIEW_CONTAINER);
var OpenTimelineAction;
( ((function(OpenTimelineAction) {
    OpenTimelineAction.ID = 'files.openTimeline';
    OpenTimelineAction.LABEL = ( localizeWithPath(_moduleId, 5, "Open Timeline"));
    function handler() {
        return (accessor, arg) => {
            const service = accessor.get(ITimelineService);
            return service.setUri(arg);
        };
    }
    OpenTimelineAction.handler = handler;
})(OpenTimelineAction || (OpenTimelineAction = {}))));
CommandsRegistry.registerCommand(OpenTimelineAction.ID, OpenTimelineAction.handler());
MenuRegistry.appendMenuItem(MenuId.ExplorerContext, ({
    group: '4_timeline',
    order: 1,
    command: {
        id: OpenTimelineAction.ID,
        title: OpenTimelineAction.LABEL,
        icon: timelineOpenIcon
    },
    when: ( (ContextKeyExpr.and(
         (ExplorerFolderContext.toNegated()),
        ResourceContextKey.HasResource,
        TimelineHasProviderContext
    )))
}));
const timelineFilter = registerIcon('timeline-filter', Codicon.filter, ( localizeWithPath(_moduleId, 6, 'Icon for the filter timeline action.')));
MenuRegistry.appendMenuItem(MenuId.TimelineTitle, {
    submenu: MenuId.TimelineFilterSubMenu,
    title: ( localizeWithPath(_moduleId, 7, "Filter Timeline")),
    group: 'navigation',
    order: 100,
    icon: timelineFilter
});

export { TimelinePaneDescriptor };
